import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./api/http";
import moment from 'moment';
import 'moment/locale/zh-cn';

import ElementUI from "element-ui";
import "@/styles/element-index.css";
import "@/styles/index.scss"; 
import config from "./config.js";

Vue.config.productionTip = false;
Vue.use(ElementUI, { size: "small", zIndex: 3000 });
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;

//相对时间
Vue.filter('datefmt', function (input, fmtstring) {//当input为时间戳，需转为Number类型
  if (input == '') return '';
  input = input + '';
  input = input.length < 13 ? Number(input + '000') : input;

  /*小于一周，使用相对时间显示*/
  var now = new Date();
  if (input + 1000 * 60 * 60 * 24 * 7 >= now.getTime()) {
    return moment(input).fromNow();
  } else {
    return moment(input).format(fmtstring);
  }
});
//绝对时间
Vue.filter('datefmt2', function (input, fmtstring) {//当input为时间戳，需转为Number类型
  if (input == '') return '';
  input = input + '';
  input = input.length < 13 ? Number(input + '000') : input;

  return moment(input).format(fmtstring);
});

//两个世界差
Vue.filter('dateDuration', function (time2, time1, type) {
  time2 = moment(time2);
  time1 = moment(time1);
  let dura = time2.format('x') - time1.format('x');
  let tempTime = moment.duration(dura);
  if (type == 'h') tempTime.hours()
  if (type == 'm') tempTime.minutes()
  if (type == 'dh') {
    let d = tempTime.days();
    let h = tempTime.hours();
    if (d <= 0) return h + '时'
    return d + '天' + h + '时'
  }
  return tempTime.days()
});

Vue.prototype.getStat = async () => {
   http.get('home/info').then((res) => {
    if (res.code == 0) {
      //console.log(res);
      if(res.data.authorHomeInfoVO!=null) store.commit("app/SET_AUTHORSTAT", res.data.authorHomeInfoVO);
      if(res.data.editorHomeInfoVO!=null) store.commit("app/SET_EDITORSTAT", res.data.editorHomeInfoVO);
      if(res.data.financeHomeInfoVO!=null) store.commit("app/SET_FINANCESTAT", res.data.financeHomeInfoVO);
      if(res.data.expertHomeInfoVO!=null) store.commit("app/SET_EXPERTSTAT", res.data.expertHomeInfoVO);
      if(res.data.recheckHomeInfoVO!=null) store.commit("app/SET_RECHECKSTAT", res.data.recheckHomeInfoVO)
    }
  })
};

Vue.prototype.$config =  config;

router.beforeEach((to, from, next) => {
  let sysName = store.state.app.sysName;
  if (to.meta.title) {
    document.title = to.meta.title.replace('$', sysName+'投审稿系统');
  } else {
    document.title = sysName+'投审稿系统';
  }
  next()
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
